export const languageOptions = [
    {
        value: 'de',
        label: 'German'
    },
    {
        value: 'en',
        label: 'English'
    },
    {
        value: 'fr',
        label: 'French'
    },
    {
        value: 'it',
        label: 'Italian'
    },
    {
        value: 'es',
        label: 'Spanish'
    },
    {
        value: 'pt',
        label: 'Portuguese'
    },
    {
        value: 'ja',
        label: 'Japanese'
    },
    {
        value: 'zh',
        label: 'Chinese (Simplified)'
    },
    {
        value: 'zh-HK',
        label: 'Chinese (Hong Kong)'
    },
    {
        value: 'ar',
        label: 'Arabic'
    },
    {
        value: 'ko',
        label: 'Korean'
    },
    {
        value: 'th',
        label: 'Thai'
    }
]
